module.exports = __webpack_public_path__ + "static/banner-58bfbee0a14c7313930fe42f2e11ad02.png";